module.exports = __webpack_public_path__ + "static/classhook-view-clip-08e351fdfa556653e66a4dbf3703f3dd.jpg";